import React from 'react'
import './index.less'
import { CHARGE_CDN } from '../../../../utils/constants'
import { hidePhoneNum } from '../../../../utils/common'
interface SharingUserInfoPropsRule {
    data: any
}
const SharingUserInfo = (props: SharingUserInfoPropsRule) => {
    const { data } = props
    return <div className='sharing-user-info'>
        <div className='user-avator'>
            <img className='avator-img' alt="" src={data?.applyUserHeadImg || `${CHARGE_CDN}/common/unlogin-avator.png`} />
        </div>
        <div className='user-info'>
            <div className='name'>{data?.applyUserNickName || '--'}</div>
            <div className='phone'>
                <div className='num'>{hidePhoneNum(data?.applyUserPhone) || '--'}</div>
                {!!data?.applyUserPhone && <a className='call' href={`tel:${data?.applyUserPhone}`}>拨打</a>}
            </div>
        </div>
    </div>
}

export default SharingUserInfo